import { render, staticRenderFns } from "./WatermarkCard.vue?vue&type=template&id=74ac159a&scoped=true"
import script from "./WatermarkCard.vue?vue&type=script&lang=js"
export * from "./WatermarkCard.vue?vue&type=script&lang=js"
import style0 from "./WatermarkCard.vue?vue&type=style&index=0&id=74ac159a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ac159a",
  null
  
)

export default component.exports